import { JSX } from 'react';

import { EmailTextPhrases } from '@/types/email.types';
import { EmailContentProps } from './session-email-content';
import useEditableEmailFields from '../helpers/use-editable-email-fields';

const AddToCalendar = ({ emailContent, design, onEdit, sent, customContent }: EmailContentProps): JSX.Element => {
  const iCalLink = emailContent.calendarLinks?.iCal ?? '';
  const outlookLink = emailContent.calendarLinks?.outlook ?? '';
  const googleLink = emailContent.calendarLinks?.google ?? '';

  const textPhrase = (key: keyof Omit<EmailTextPhrases, 'subject'>) => {
    return emailContent.translations[key];
  };

  interface IEditableContent {
    addCalendar: JSX.Element;
  }

  const editableContent: IEditableContent = {
    addCalendar: (
      <h6 style={{ ...design.styles.h6, marginTop: '20px' }}>
        <span style={design.styles.h6Span}>{textPhrase('AddToCalendar')}</span>
      </h6>
    ),
  };

  const { getCellContent } = useEditableEmailFields<IEditableContent>({
    onEdit,
    sent,
    design,
    emailContent,
    emailContentType: 'event',
    editableContent,
    customContent,
  });

  return (
    <>
      <tr>
        <td>{getCellContent('addCalendar')}</td>
      </tr>
      <tr>
        <td align="center">
          <a style={design.styles.link} rel="noreferrer" href={iCalLink} download>
            iCal
          </a>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <a style={design.styles.link} rel="noreferrer" href={outlookLink} download>
            Outlook
          </a>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <a style={design.styles.link} target="_blank" rel="noreferrer" href={googleLink}>
            Google
          </a>
        </td>
      </tr>
    </>
  );
};

export default AddToCalendar;
